export const VISIT_STATUS = {
  admit: 'Admit',
  available: 'Available',
  bill_pending: 'Bill pending',
  bill_rejected: 'Bill rejected',
  bill_submitted: 'Bill submitted',
  checked_in: 'Checked In',
  claim_assigned: 'Claim assigned',
  completed: 'Completed',
  last: 'Last',
  not_seen: 'Not seen',
  scheduled: 'Scheduled',
  super_bill: 'Superbill',
}

export const BUTTON_STATUS = {
  bill: 'Bill',
  billSalt: 'Bill SALT',
  confirm: 'Confirm',
  cosign: 'CO-SIGN',
  discharge: 'Discharge',
  download_note: 'Download Notes',
  recall: 'Recall bill',
  skip: 'Skip',
  undo_discharge: 'Undo discharge',
  undo_skip: 'Undo skip',
  void: 'Void',
}

export const STATUS_GROUPS = {
  in_complete: 'Incomplete',
  completed: 'Completed',
  available: 'Available',
}
